import ErrorComponent from "components/error"

interface ErrorStateProps {
  status?: number
}

export default function ErrorState({ status }: ErrorStateProps) {
  if (status === 404 || status === 403) {
    return (
      <div className="sigma-embed-error">
        <h2>Solution Not Found</h2>
        <p>The requested Sigma dashboard does not exist.</p>
      </div>
    )
  }

  return <ErrorComponent />
}
